import Model, { attr } from '@ember-data/model';

export default class HorizonMetricRecord extends Model {
	@attr('string') name!: string;
	@attr('number') spaceAccessId!: number;
	@attr('number') created!: number;
	@attr('number') createdBy!: number;
	@attr('number') modified!: number;
	@attr('number') modifiedBy!: number;
	@attr() tags!: number[];
	@attr() statusObject!: { level: string; title?: string; description?: string };
	@attr() verificationInfo!: {
		status?: number;
		created?: number;
		createdBy?: number;
		modified?: number;
		modifiedBy?: number;
	} | null;
}
